import { cn } from "@util/tailwind";

interface SkillBadgeProps {
    label: string;
    className?: string;
}

export default function SkillBadge({ label, className }: SkillBadgeProps) {
    return (
        <span
            className={cn(
                "bg-blue-100  text-blue-800 px-3 py-1 rounded-full text-xs",
                className
            )}
        >
            {label}
        </span>
    );
}
